/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Scroll Lock Safety Check
  // Periodically checks if body is incorrectly locked and unlocks it when no overlays are open
  (function initScrollLockSafetyCheck() {
    const SCROLL_LOCK_CHECK_INTERVAL = 2000; // Check every 2 seconds

    // Classes/attributes that indicate something requiring scroll lock is open
    const OPEN_STATE_INDICATORS = {
      // Body classes that indicate drawers/modals are open
      bodyClasses: [
        'js-drawer-open',
        'js-drawer-open-cart',
        'js-quick-view-visible',
        'js-quick-view-from-cart'
      ],
      // Header class that indicates mega menu is open
      headerClass: 'site-header--menu-opened',
      // Selectors for elements that indicate something is open
      openElementSelectors: [
        '.drawer.is-open',
        'header-menu-toggle[aria-expanded="true"]',
        '[data-nav-item].is-open',
        '.popup--is-active',
        '[data-popup-modal].is-visible'
      ]
    };

    // Attributes that indicate scroll is locked
    const SCROLL_LOCK_ATTRIBUTES = [
      'data-scroll-locked',
      'data-scroll-lock-locked'
    ];

    function isScrollLocked() {
      const html = document.documentElement;
      const body = document.body;

      // Check for scroll lock attribute on html
      if (html.hasAttribute('data-scroll-locked')) {
        return true;
      }

      // Check for scroll lock attribute on body
      if (body.hasAttribute('data-scroll-lock-locked')) {
        return true;
      }

      // Check if body has overflow:hidden inline style (from scroll-lock library)
      const bodyStyle = body.style.overflow;
      if (bodyStyle === 'hidden') {
        return true;
      }

      return false;
    }

    function isAnyOverlayOpen() {
      const body = document.body;
      const header = document.querySelector('[data-site-header]') || document.querySelector('.site-header');

      // Check body classes
      for (const className of OPEN_STATE_INDICATORS.bodyClasses) {
        if (body.classList.contains(className)) {
          return true;
        }
      }

      // Check header class for mega menu
      if (header && header.classList.contains(OPEN_STATE_INDICATORS.headerClass)) {
        return true;
      }

      // Check for open elements
      for (const selector of OPEN_STATE_INDICATORS.openElementSelectors) {
        try {
          if (document.querySelector(selector)) {
            return true;
          }
        } catch (e) {
          // Invalid selector, skip
        }
      }

      return false;
    }

    function unlockScroll() {
      const html = document.documentElement;
      const body = document.body;

      console.warn('[Scroll Lock Safety] Detected stuck scroll lock. Auto-unlocking...');

      // Try to use the scroll-lock library if available
      if (window.theme && window.theme.scrollLock) {
        try {
          window.theme.scrollLock.clearQueueScrollLocks();
          window.theme.scrollLock.enablePageScroll();
        } catch (e) {
          console.warn('[Scroll Lock Safety] Error using theme.scrollLock:', e);
        }
      }

      // Also try the global ScrollLock if available (from vendor.js)
      if (window.scrollLock) {
        try {
          window.scrollLock.clearQueueScrollLocks();
          window.scrollLock.enablePageScroll();
        } catch (e) {
          console.warn('[Scroll Lock Safety] Error using scrollLock:', e);
        }
      }

      // Manual cleanup as fallback
      html.removeAttribute('data-scroll-locked');
      body.removeAttribute('data-scroll-lock-locked');
      body.removeAttribute('data-scroll-lock-saved-overflow-y-property');
      body.removeAttribute('data-scroll-lock-saved-inline-overflow-property');
      body.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
      body.removeAttribute('data-scroll-lock-filled-gap');
      body.removeAttribute('data-scroll-lock-current-fill-gap-method');

      // Reset inline styles that might be causing the lock
      if (body.style.overflow === 'hidden') {
        body.style.overflow = '';
      }
      if (body.style.overflowY === 'hidden') {
        body.style.overflowY = '';
      }
      if (body.style.paddingRight) {
        body.style.paddingRight = '';
      }
      if (body.style.marginRight) {
        body.style.marginRight = '';
      }

      console.log('[Scroll Lock Safety] Scroll lock cleared successfully');
    }

    function checkScrollLock() {
      if (isScrollLocked() && !isAnyOverlayOpen()) {
        unlockScroll();
      }
    }

    // Start the periodic check after DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setInterval(checkScrollLock, SCROLL_LOCK_CHECK_INTERVAL);
      });
    } else {
      setInterval(checkScrollLock, SCROLL_LOCK_CHECK_INTERVAL);
    }

    // Also check on visibility change (when user returns to tab)
    document.addEventListener('visibilitychange', function() {
      if (!document.hidden) {
        // Small delay to let any transition complete
        setTimeout(checkScrollLock, 500);
      }
    });

    // Expose function globally for debugging
    window.__scrollLockSafetyCheck = {
      check: checkScrollLock,
      isLocked: isScrollLocked,
      isOverlayOpen: isAnyOverlayOpen,
      unlock: unlockScroll
    };

    console.log('[Scroll Lock Safety] Initialized - checking every', SCROLL_LOCK_CHECK_INTERVAL / 1000, 'seconds');
  })();

  // Custom code: lazy pdf
  console.log("run")
  document.addEventListener("DOMContentLoaded", function initLazyPDFs() {
    console.log("run")
    const pdfs = document.querySelectorAll("[data-lazy-load-pdf]")
    pdfs.forEach(function (el) {
      console.log({el})
      const observer = new IntersectionObserver((entries, obs) => {
      if (entries[0].isIntersecting) {
          el.src = el.dataset.src;
          obs.disconnect();
        }
      });
      observer.observe(el);
    })
  });

  // Custom code: Optimized Trustpilot & Reputon widget loading
  (function initTrustpilotReputon() {
    let fontsLoaded = false;
    let scriptLoaded = false;

    // Load Google Fonts asynchronously after page load (non-blocking)
    function loadGoogleFont() {
      if (fontsLoaded || document.querySelector('link[href*="fonts.googleapis.com/css2?family=Host+Grotesk"]')) {
        return; // Already loaded
      }
      fontsLoaded = true;
      
      const link = document.createElement('link');
      link.href = 'https://fonts.googleapis.com/css2?family=Host+Grotesk&text=Trustpilot';
      link.rel = 'stylesheet';
      // Use media="print" trick to load asynchronously, then switch to "all"
      link.media = 'print';
      link.onload = function() {
        this.media = 'all';
      };
      link.onerror = function() {
        fontsLoaded = false; // Allow retry on error
      };
      document.head.appendChild(link);
    }

    // Load Reputon script asynchronously after page load
    function loadReputonScript() {
      if (scriptLoaded || document.querySelector('script[src*="cdn.grw.reputon.com"]')) {
        return; // Already loaded
      }
      scriptLoaded = true;

      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://cdn.grw.reputon.com/assets/widget.js?shop=eco-dutty.myshopify.com';
      script.async = true;
      script.defer = true;
      script.onerror = function() {
        scriptLoaded = false; // Allow retry on error
      };
      document.body.appendChild(script);
    }

    // Load resources after page is fully loaded (non-blocking)
    function initLoading() {
      // Use requestIdleCallback if available for better performance, otherwise use setTimeout
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function() {
          loadGoogleFont();
          loadReputonScript();
        }, { timeout: 2000 });
      } else {
        setTimeout(function() {
          loadGoogleFont();
          loadReputonScript();
        }, 1);
      }
    }

    // Start loading after page is loaded
    if (document.readyState === 'complete') {
      initLoading();
    } else {
      window.addEventListener('load', initLoading, { once: true });
    }
  })();







  // Custom code: Natural Raw color disclaimer
  // Shows a disclaimer note whenever a customer selects an untreated "Natural Raw"
  // (or "Raw Natural") color swatch, explaining that natural fibre imperfections are
  // expected and are not a defect. The CSS for this lives inline in the Liquid snippet
  // so it is guaranteed to load even if this script does not.
  (function initNaturalRawDisclaimer() {
    var NATURAL_RAW_NAMES = ['natural raw', 'raw natural'];

    function normalize(value) {
      if (!value) return '';
      return String(value)
        .toLowerCase()
        .trim()
        .replace(/[-_]+/g, ' ')
        .replace(/\s+/g, ' ');
    }

    function isNaturalRaw(value) {
      return NATURAL_RAW_NAMES.indexOf(normalize(value)) !== -1;
    }

    // Find the color-option wrapper that contains a given disclaimer. The disclaimer
    // is a direct child of the selector-wrapper div, so parentElement is the wrapper.
    function getWrapperFor(disclaimer) {
      return disclaimer.parentElement || null;
    }

    function updateDisclaimer(disclaimer) {
      var wrapper = getWrapperFor(disclaimer);
      if (!wrapper) return;
      var checkedInput = wrapper.querySelector(
        'input[type="radio"][data-single-option-selector]:checked'
      );
      var shouldShow = !!(checkedInput && isNaturalRaw(checkedInput.value));
      disclaimer.classList.toggle('hidden', !shouldShow);
    }

    function updateAllDisclaimers(root) {
      var scope = root || document;
      var disclaimers = scope.querySelectorAll('[data-natural-raw-disclaimer]');
      for (var i = 0; i < disclaimers.length; i++) {
        updateDisclaimer(disclaimers[i]);
      }
    }

    function handleOptionChange(event) {
      var target = event.target;
      if (
        !target ||
        typeof target.matches !== 'function' ||
        !target.matches('input[type="radio"][data-single-option-selector]')
      ) {
        return;
      }
      // The radio and its sibling disclaimer share a selector-wrapper ancestor.
      var wrapper = target.closest('[data-option-position]');
      if (wrapper) {
        var disclaimer = wrapper.querySelector('[data-natural-raw-disclaimer]');
        if (disclaimer) updateDisclaimer(disclaimer);
      } else {
        updateAllDisclaimers(document);
      }
    }

    // Delegated listener survives AJAX re-renders of the product form.
    document.addEventListener('change', handleOptionChange, true);

    function init() {
      updateAllDisclaimers(document);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
